


































































































































































import { defineComponent, reactive, toRefs, computed, onMounted, onBeforeUnmount, ref } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import PreviewImageArea from "../../components/PreviewImageArea.vue";
import { Sheet, PreviewImageTypeEnum, QuestionImageDiscription } from "../../modules/digital_paper/AnswerInput"
import { SplitterComponent, PanesDirective, PaneDirective, ResizingEventArgs } from "@syncfusion/ej2-vue-layouts"
import VSwatches from 'vue-swatches'
import "vue-swatches/dist/vue-swatches.css"


export interface Data {
  initiarizedData: boolean
  sheet: Sheet
  student_no: number
  base64AnswerImages: string[]
  base64QuestionImages: string[]
  base64CorrectImages: string[]
  direction: number
  mainAreaWidth: number
  mainAreaHeight: number
  horizonTopHeightPer: number
  horizonBottomHeightPer: number
  verticalLeftWidthPer: number
  verticalRightWidthPer: number
  separatorSize: number
  selectedAnswerPageIdx: number
  selectedQuestionPageIdx: number
  selectedCorrectPageIdx: number
  errors: string[]
  PreviewImageTypeEnum: Readonly<{None: number; Question: number; Correct: number; Answer: number;}>
  previewImageType: number
  isDispToggre: boolean
  keyCode: string
  fromStudentSheetList: boolean
  isScoring: boolean
  resultPdfUrl: string
  curriculum_name: string
  subject_name: string
  questionImageDiscriptions: QuestionImageDiscription[]
}

// @ts-ignore
export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "preview-image-area": PreviewImageArea,
    "ejs-splitter" : SplitterComponent,
    "e-panes": PanesDirective,
    "e-pane": PaneDirective,
    "v-swatches": VSwatches,
  },
  setup(props, context){

    const DirectionEnum = Common.DirectionEnum;

    const horizonAnswerImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();
    const verticalAnswerImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();
    const horizonQuestionImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();
    const horizonCorrectImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();
    const verticalQuestionImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();
    const verticalCorrectImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();

    /******************************
     * data
     ******************************/
    const state = reactive<Data>({
      initiarizedData: false,
      sheet: null,
      student_no: null,
      base64AnswerImages: [],
      base64QuestionImages: [],
      base64CorrectImages: [],
      direction: DirectionEnum.Vertical,
      mainAreaWidth: 0,
      mainAreaHeight: 0,
      horizonTopHeightPer: 0.5,
      horizonBottomHeightPer: 0.5,
      verticalLeftWidthPer: 0.5,
      verticalRightWidthPer: 0.5,
      separatorSize: 10,
      selectedAnswerPageIdx: 0,
      selectedQuestionPageIdx: 0,
      selectedCorrectPageIdx: 0,
      errors: [],
      PreviewImageTypeEnum: PreviewImageTypeEnum,
      previewImageType: PreviewImageTypeEnum.None,
      isDispToggre: false,
      keyCode: null,
      fromStudentSheetList: false,
      isScoring: false,
      resultPdfUrl: "",
      curriculum_name: null,
      subject_name: null,
      questionImageDiscriptions: [],
    });

    /************************************************************
     * メインエリアの高さを画面サイズに合わせてリサイズ
     * 初期表示・ウィンドウリサイズ時に発動
     ************************************************************/

    const adjustHeight = () => {
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      const mainArea = document.getElementById("main-area");
      
      if(mainArea != null){
        state.mainAreaHeight = windowHeight - mainArea.offsetTop;
        state.mainAreaWidth = windowWidth;
        mainArea.style.width = state.mainAreaWidth + "px";
        mainArea.style.height = windowHeight - mainArea.offsetTop + "px";
      }
    };

    /************************************************************
     * 横向きモードのスプリッターリサイズ
     ************************************************************/

    const horizonHeightPaneResizing = (e: ResizingEventArgs) => {
      state.horizonTopHeightPer = e.paneSize[0] / state.mainAreaHeight;
      state.horizonBottomHeightPer = e.paneSize[1] / state.mainAreaHeight;
    }

    /************************************************************
     * 縦向きモードのスプリッターリサイズ
     ************************************************************/

    const verticalWidthPaneResizing = (e: ResizingEventArgs) => {
      state.verticalLeftWidthPer = e.paneSize[0] / state.mainAreaWidth;
      state.verticalRightWidthPer = e.paneSize[1] / state.mainAreaWidth;
    }

    /************************************************************
     * 横向きモードの上部エリアのheight
     ************************************************************/

    const horizonModeTopHeight = computed((): any => {
      return state.mainAreaHeight * state.horizonTopHeightPer;
    });

    /************************************************************
     * 横向きモードの下部エリアのheight
     ************************************************************/

    const horizonModeBottomHeight = computed((): any => {
      return state.mainAreaHeight * state.horizonBottomHeightPer;
    });

    /************************************************************
     * 画面レイアウト縦横モード切り替え
     ************************************************************/

    const changeDirection = (direction: number) => {
      if(state.direction != direction){
        state.direction = direction;
      }
    }

    /******************************
     * 解答用紙ページ切り替え時のemit
     ******************************/

    const answerSheetPageChanged = (idx: number) => {
      state.selectedAnswerPageIdx = idx;
    }

    /******************************
     * 問題用紙ページ切り替え時のemit
     ******************************/

    const questionSheetPageChanged = (idx: number) => {
      state.selectedQuestionPageIdx = idx;
    }

    /******************************
     * 模範解答｀ページ切り替え時のemit
     ******************************/

    const correctImagePageChanged = (idx: number) => {
      state.selectedCorrectPageIdx = idx;
    }

    /******************************
     * 問題用紙・模範解答表示切り替え
     ******************************/

    const changeImageType = (imageType: number) => {
      state.previewImageType = imageType;
    }

    /************************************************************
     * ピンチインアウトによる画面の拡大縮小禁止処理
     ************************************************************/

    const rootTouchmove = (e: TouchEvent) => {
      if(e.touches.length > 1){
        e.preventDefault();
      }
    }

    /************************************************************
     * 問題用紙・解答用紙を画面内に収まるようにリサイズ
     ************************************************************/

    const adjustSheet = () => {
      const answerArea = document.getElementById(`answer-page-root-${state.direction}`);
      const mainArea = document.getElementById("main-area");

      const areaW = answerArea.clientWidth - 16;
      const areaH = mainArea.clientHeight - 80;

      if(answerArea && mainArea){
        let scaleW = areaW / state.sheet.width;
        let scaleH = areaH / state.sheet.height;
        let scale = scaleW > scaleH ? scaleH * 100 : scaleW * 100;

        verticalAnswerImageAreaRef.value.inputScale = scale;
        horizonAnswerImageAreaRef.value.inputScale = scale;

        if(verticalCorrectImageAreaRef.value){
          verticalCorrectImageAreaRef.value.inputScale = scale;
          horizonCorrectImageAreaRef.value.inputScale = scale;
        }

        if(verticalQuestionImageAreaRef.value){
          scaleW = areaW / state.sheet.questionImageWidth;
          scaleH = areaH / state.sheet.questionImageHeight;
          scale = scaleW > scaleH ? scaleH * 100 : scaleW * 100;

          verticalQuestionImageAreaRef.value.inputScale = scale;
          horizonQuestionImageAreaRef.value.inputScale = scale;
        }
      }
    }

    /******************************
     * 答案PDFダウンロード
     ******************************/

    const downloadImage = async () => {

      if(!window.confirm(`採点結果画像をダウンロードします。よろしいですか？`)){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      
      await http.get(state.resultPdfUrl, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `${state.sheet.name}_${context.root.$store.getters.getCurriculumNameById(state.sheet.curriculum_id)}.pdf`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = JSON.parse(new TextDecoder().decode(error.response.data)).errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * mounted
     ************************************************************/

    onMounted(async () => {

      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");

      if(context.root.$store.state.isKaitouViewReloaded){
        context.root.$store.commit("setIsKaitouViewReloaded", false);
      }else{
        context.root.$store.commit("setIsKaitouViewReloaded", true);
        window.location.reload();
        return;
      }
      
      let param = `sheet_id=${context.root.$route.params.sheet_id}`;
      if(context.root.$store.state.student_no_character){
        param += `&student_no_character=${context.root.$store.state.student_no_character}`
      }else{
        param += `&email=${context.root.$store.state.digitalPaperEmail}`
      }

      await http.get(`/api/student/result_image_preview?${param}`).then(async response => {
        state.sheet = new Sheet(response.data.sheet);
        state.student_no = response.data.student_no;
        state.curriculum_name = response.data.curriculum_name;
        state.subject_name = response.data.subject_name;
        state.isScoring = response.data.is_scoring;

        for(let i = 0; i < response.data.base64_answer_images.length; i++){
          const base64_answer_image = response.data.base64_answer_images[i];
          const baseCanvas = document.createElement("canvas");
          baseCanvas.width = response.data.anwser_image_size_hashes[i].width;
          baseCanvas.height = response.data.anwser_image_size_hashes[i].height;
          const image = await loadImage(`data:image/jpeg;base64,${base64_answer_image}`);
          const context = baseCanvas.getContext('2d');
          context.drawImage(image, 0, 0);

          const reviewTexts = response.data.review_texts.filter((x: any) => x.page == i + 1);
          for(let i = 0; i < reviewTexts.length; i++){
            const reviewText = reviewTexts[i];
            const reviewCanvas = document.createElement("canvas");
            reviewCanvas.width = reviewText.width;
            reviewCanvas.height = reviewText.height;
            const reviewImage = await loadImage(`data:image/png;base64,${reviewText.base64_text}`);
            context.drawImage(reviewImage, reviewText.x, reviewText.y);
          }

          state.base64AnswerImages.push(baseCanvas.toDataURL("image/jpeg").replace("data:image/jpeg;base64,", ""));
        }

        state.base64QuestionImages = response.data.base64_question_images;
        state.base64CorrectImages = response.data.base64_correct_images;

        state.previewImageType = PreviewImageTypeEnum.Correct;
        state.isDispToggre = state.sheet.question_image_completed;

        state.resultPdfUrl = response.data.result_pdf_url;
      })
      .catch(async error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。レポート一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。レポート一覧に戻ります。`);
        }
        window.history.back();
      });

      state.initiarizedData = true;
      context.root.$nextTick(() => {
        adjustHeight();
        adjustSheet();
      });
      window.addEventListener("resize", adjustHeight);
      window.addEventListener("orientationchange", adjustHeight);

      context.root.$store.dispatch("hideOverlay");
    });

    const loadImage = async (src: string): Promise<HTMLImageElement> => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = src;
      });
    }

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
      window.removeEventListener("orientationchange", adjustHeight);
    });

    return {
      ...toRefs(state),
      DirectionEnum,
      horizonAnswerImageAreaRef,
      verticalAnswerImageAreaRef,
      horizonQuestionImageAreaRef,
      horizonCorrectImageAreaRef,
      verticalQuestionImageAreaRef,
      verticalCorrectImageAreaRef,
      horizonHeightPaneResizing,
      verticalWidthPaneResizing,
      horizonModeTopHeight,
      horizonModeBottomHeight,
      changeDirection,
      answerSheetPageChanged,
      questionSheetPageChanged,
      correctImagePageChanged,
      rootTouchmove,
      changeImageType,
      downloadImage,
     };
  }
})
